import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class SetPinCodeResolverService  {

    //#region Constructor

    /**
     * Class Constructor
     */
    constructor()
    {

    }
    //#endregion


    //#region Methods

    /**
     * 
     * @param route 
     * @returns 
     */
    async resolve(route: ActivatedRouteSnapshot)
    {
        let result = route.queryParams[ 'result' ];
        return result;
    }
    //#endregion
}